/* eslint-disable camelcase */
import { FC } from 'react';
import { Text, Button, Icon } from '@livechat/design-system-react-components';
import Cookies from 'js-cookie';

import { useGetMe } from 'hooks/use-get-me';
import { useProducts } from 'hooks/use-products';
import { OrganizationGraphQLResponse } from 'hooks/use-organizations';
import Amplitude from 'services/Amplitude';
import { getAppLinkByName, getProductDisplayName, getProductName } from 'helpers/product';
import { pushExternalRedirectToDataLayer } from 'helpers/tracking';
import { getLogoSource } from 'helpers/logo';

import * as styles from './styles';

type Props = {
  organization: OrganizationGraphQLResponse;
  product: string;
};

export const AccessibleProductButton: FC<Props> = ({
  organization: { organization_id },
  product,
}) => {
  const { email } = useGetMe();
  const { getRedirectUrl, isFetchingProducts } = useProducts();

  const handleGoToProduct = () => {
    pushExternalRedirectToDataLayer(getAppLinkByName(product));
    Amplitude.logEvent(
      email,
      'LOGIN_GO_TO_PRODUCT_CLICK',
      { product, productCookie: getProductName(Number(Cookies.get('product'))) },
      true
    );
  };

  return (
    <div>
      <Button
        data-testid={`accessible-product-button-${product.toLowerCase()}`}
        kind="secondary"
        css={styles.goToProductButton('secondary')}
        href={getRedirectUrl(product, organization_id)}
        onClick={handleGoToProduct}
        loading={isFetchingProducts}
      >
        <Icon source={getLogoSource(product)} />
        <Text bold css={styles.goToProductButtonText(true)}>
          Go to {getProductDisplayName(product)}
        </Text>
      </Button>
    </div>
  );
};
